import React, { useContext, useEffect, useState } from "react";
import { isDateFinalized, setDateHelper, userDetails } from "../../utils/Helper";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg'
import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import ValidationMessage from "../../constants/ValidationMessage";
import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import Select from "react-select";
import toast from "react-hot-toast";
import Skeleton from "../../components/ui/Skeleton";
import DoNotSellValidation from "../../validations/cms/DoNotSellValidation";
import { Device } from "@capacitor/device";
import { ApiTypes } from "../../constants/Constants";


const DoNotSellMyPersonalInfoModal = ({ cmsPage }: any) => {

    const [isIos, setIsIos] = useState(false);


    const countries = useMakeRequest();
    const localities = useMakeRequest();
    const states = useMakeRequest();
    const profile: any = useContext(authContext);
    const doNotSell = useMakeRequest();


    const { register, watch, setValue, formState: { errors }, handleSubmit, trigger, getValues } = useForm<any>({
        mode: 'onChange',
        resolver: yupResolver(DoNotSellValidation) as any
    });

    useEffect(() => {
        console.log("profile?.data: ", profile?.data)
        if (profile?.data) {
            setValue('name', profile?.data.name);
            setValue('email', profile?.data.email);
            setValue('phone_country_code', profile?.data?.phone_country_code)
            setValue('phone_number', profile?.data?.phone_number)
            setValue('profile_pic', profile?.data?.profile_pic)
            setValue('country', profile?.data?.country)
            setValue('state', profile?.data?.state);
            setValue('locality', profile?.data?.locality_detail);
            setValue('income', profile?.data?.income);
            setValue('monthly_work_hour', profile?.data?.monthly_work_hour);
            setValue('receive_marketing_emails', profile?.data?.receive_marketing_emails);
            setValue('share_usage_data', profile?.data?.share_usage_data);
        }
    }, [profile?.data])

    useEffect(() => {
        countries.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 1, showAll: true } })

        const checkDeviceType = async () => {
            const info = await Device.getInfo()
            if (info?.platform === 'ios') {
                setIsIos(true)
            }
        }
        checkDeviceType()
    }, [])

    useEffect(() => {
        if (countries?.status) {
            setValue('country', countries?.data?.data[0]?.value)
        }
    }, [countries?.status])

    useEffect(() => {
        if (watch('country')) {
            states.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 2, showAll: true, list_id: watch('country') } })
        }
    }, [watch('country')])

    useEffect(() => {
        if (watch('state')) {
            localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 3, showAll: true, list_id: watch('state') } })
        }
    }, [watch('state')])

    const onSubmit = (data: any) => {
        console.log("data - - - ", data)
        const payload = {
            country: data?.country,
            state: data?.state,
            name: data?.name,
            email: data?.email,
        }


        toast.promise(
            doNotSell.makeRequest({ url: ApiConstants?.DoNOTSaleMyPersonalInfo, payload, type: ApiTypes?.POST }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }


    useEffect(() => {
        if (doNotSell.status) {
            $('.btn-close').click()
        }
    }, [doNotSell.status])


    return (
        <div className="modal fade inner-modal c" id="personalLinkModal" tabIndex={-1} aria-labelledby="personalLinkModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="personalLinkModalLabel">{"Do Not Sell My Personal Info"}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {
                            cmsPage?.loading ?
                                <>
                                    <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />

                                    <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                    <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />
                                </>
                                :
                                <div className="auth-page pt-0">
                                    <form onSubmit={handleSubmit(onSubmit)} className='auth-form-wrap mt-0'>

                                        <div className="mb-3 com-input-grp">
                                            <label className="form-label">Country<span className='label-star'>*</span></label>
                                            <div className='custom-select'>
                                                <ReactSelect
                                                    options={countries?.data?.data}
                                                    value={{ value: countries?.data?.data?.[0]?.value, label: countries?.data?.data?.[0]?.label }}
                                                    className="com-r-select"
                                                    classNamePrefix="com-r-select"
                                                    placeholder="Please select household name"
                                                    onChange={(selectedOption: any) => {
                                                        setValue("country", selectedOption ? selectedOption?.value : "");
                                                        trigger("country")
                                                    }}
                                                    closeMenuOnScroll={true}
                                                    closeMenuOnSelect={true}
                                                    isLoading={countries?.loading}
                                                />
                                            </div>
                                            <ErrorMessage errors={errors} name="country" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                        </div>

                                        <div className="mb-3 com-input-grp">
                                            <label className="form-label">State<span className='label-star'>*</span></label>
                                            <div className='custom-select'>
                                                <ReactSelect
                                                    options={states?.data?.data}
                                                    className="com-r-select"
                                                    classNamePrefix="com-r-select"
                                                    defaultValue={profile?.data?.state_detail}
                                                    // value={watch('state')}
                                                    // value={{ value: 1, label: state }}
                                                    // value={watch("state")}
                                                    placeholder="Select state"
                                                    onChange={(selectedOption: any) => {
                                                        setValue("state", selectedOption ? selectedOption?.value : "");
                                                        trigger("state")
                                                        setValue('locality', null)
                                                        localities.makeRequest({ url: ApiConstants?.LocationGet, payload: { type: 3, list_id: selectedOption?.value, showAll: true } })
                                                    }}
                                                    closeMenuOnScroll={true}
                                                    closeMenuOnSelect={true}
                                                    isLoading={states?.loading}
                                                />
                                            </div>
                                            <ErrorMessage errors={errors} name="state" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                        </div>

                                        <div className="mb-3 com-input-grp">
                                            <label className="form-label">Name<span className='label-star'>*</span></label>
                                            <input type="text" className="form-control" placeholder='Enter name' {...register('name')} />
                                            <ErrorMessage errors={errors} name="name" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                        </div>

                                        <div className="mb-3 com-input-grp">
                                            <label className="form-label">Email<span className='label-star'>*</span></label>
                                            <input type="email" className="form-control" placeholder='Enter email' {...register('email')} />
                                            <ErrorMessage errors={errors} name="email" render={({ message }) => <p className='valid-error'>{message}</p>} />
                                        </div>



                                        {/* <button className='com-btn my-5 mx-auto' >Continue</button> */}
                                        <Button text='Continue' className='com-btn my-5 mx-auto' type="submit" loading={doNotSell.loading}>Save</Button>
                                    </form>

                                </div>

                        }     </div>
                    {/* <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary">Save changes</button>
            </div> */}
                </div>
            </div>
        </div>
    )
}

export default DoNotSellMyPersonalInfoModal